import { ComponentPropsWithRef } from "react";

export const DeleteIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36.0431 16.4432C36.375 16.4432 36.6434 16.1748 36.6434 15.8429V13.6134C36.6434 13.2815 36.375 13.0131 36.0431 13.0131H12.6003C12.2684 13.0131 12 13.2815 12 13.6134V15.8429C12 16.1748 12.2684 16.4432 12.6003 16.4432H13.7528V36.57V40.0001H34.8906V36.57V16.4432H36.0431ZM19.6551 36.57H17.182V16.4432H19.6551V36.57ZM25.5582 36.57H23.0851V16.4432H25.5582V36.57ZM31.4614 36.57H28.9883V16.4432H31.4614V36.57Z"
      fill="currentColor"
    />
    <path
      d="M28.3961 10.8298L28.3961 8.60026C28.3961 8.26875 28.1274 8 27.7959 8L20.8062 8C20.4747 8 20.206 8.26875 20.206 8.60026L20.206 10.8298C20.206 11.1613 20.4747 11.4301 20.8062 11.4301L27.7959 11.4301C28.1274 11.4301 28.3961 11.1613 28.3961 10.8298Z"
      fill="currentColor"
    />
  </svg>
);
